import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface TrimProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Trim: React.FC<TrimProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [trim, setTrim] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Trim'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Trim: v } } })
    );
    const label = 'Trim';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={trim}
                />
            ) : (
                <TextBox
                    value={trim ?? ''}
                    onChange={(value) => setTrim(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
